import { useFormikContext } from 'formik';
import { LocationPickerField } from '../../components';
import { ISSUE_ATTRIBUTE_NAMES } from '../../constants/issue-attribute-names';
import { useRfiForm } from '../RfiFormProvider';
import { RfiCreateFormValues } from '../types';

const Location = () => {
  const formik = useFormikContext<RfiCreateFormValues>();
  const { mandatoryFields, isSubmitting, refs } = useRfiForm();
  const fieldName = ISSUE_ATTRIBUTE_NAMES.LOCATION_IDS;
  const isFieldsMandatory = mandatoryFields.includes(fieldName);
  const errorMessage = formik.touched[fieldName] && formik.errors[fieldName];

  const handleSelectLocationIds = (selectedLocationIds: string[]) => {
    formik.setFieldValue(fieldName, selectedLocationIds);
  };

  const selectedLocationIds = formik.values[fieldName];

  return (
    <LocationPickerField
      key={fieldName}
      selectedLocationIds={selectedLocationIds}
      disabled={isSubmitting}
      error={errorMessage}
      required={isFieldsMandatory}
      onChangeLocationIds={handleSelectLocationIds}
      data-testid="IssueCreateForm__location"
      ref={refs[fieldName]}
    />
  );
};

export default Location;
